import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
<section id="info-hiking-stick" className="about-us pt-trip gray-light-bg">
  <div className="container">
    <div className="row justify-content-center">
      <div>
        <div className="section-heading mb-5 mx-2">
          {this.props.showTitle && this.props.showTitle === true && (
            <span className="badge badge-primary badge-pill">
              How to Make a Hiking Stick
            </span>
          )}
          <h1 className="text-center">
            How to Make a Hiking Stick With Just a Knife (Easy Step-by-Step Guide)
            <br />
          </h1>

          <p>
            If you need a hiking stick right now, here is the simplest way to make one using just a knife.
            Find a straight, solid branch that reaches about your wrist when your arm hangs naturally at your side,
            cut or snap it to size, strip bark where your hand will grip, and sharpen the bottom slightly for traction.
          </p>

          <p>
            A simple hiking stick can improve balance on uneven terrain, reduce strain on your knees,
            and help you feel more stable on steep or slippery trails.
          </p>

          <p>
            If you need more tips on technique, please visit our complete guide on <a className="in-text-link" href="/how-to-use-hiking-poles-correctly">
              How to Use Hiking Poles Correctly
            </a>.
          </p>

          <p>
            This guide explains how to make a hiking stick with just a knife, including how to choose the right wood,
            cut it to the correct height, shape the tip, and create a comfortable grip for the trail.
          </p>
          <FAQAccordion
            title="How to Make a Hiking Stick FAQs"
            items={[
              { q: 'What is the best wood for making a hiking stick?', a: 'Hardwoods like oak, ash, hickory, and maple are the most durable. Lighter woods like hazel or alder are easier to carry on long hikes. Avoid softwoods like pine or spruce — they splinter easily under weight.' },
              { q: 'How tall should a homemade hiking stick be?', a: 'The stick should reach approximately your wrist height when your arm hangs naturally at your side. For most adults this is between 48 and 55 inches. Taller for flat terrain, shorter for steep descents.' },
              { q: 'What tools do you need to make a hiking stick?', a: 'A fixed-blade knife is the minimum — use it to strip bark, shape the tip, and smooth rough spots. A draw knife, sandpaper, and a file make the job easier. A hand drill can add a hole for a wrist strap.' },
              { q: 'How do you strip bark off a hiking stick?', a: 'Score along the grain with your knife, then peel back sections. Green (freshly cut) wood strips easily. Dry the stick for a few days after stripping to prevent cracking, or it may split as it dries.' },
              { q: 'How do you add a grip to a homemade hiking stick?', a: 'Wrap the grip area with paracord, leather cord, or athletic tape for a comfortable, non-slip handle. Sand the wood smooth first. Some hikers use rubber handlebar tape from a bike shop.' },
              { q: 'Is a homemade hiking stick as good as a store-bought trekking pole?', a: 'For casual hiking and day hikes, a well-made wooden stick works very well. Trekking poles offer adjustable length, lighter weight, and shock-absorbing tips for technical terrain and long trips.' },
            ]}
          />
        </div>
      </div>
    </div>
  </div>
</section>
      </React.Fragment>
    );
  }
}
export default About;